<template>
  <v-dialog persistent v-model="dialog" >
    <v-card>
       <v-toolbar flat color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h3>View blog</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn flat @click="$emit('closeDialog')">Close</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout>
          <v-flex sm12 class="output-layout">
            <div class="output">
              <div class="pl-4 pr-4">
                <div class="mt-3 ml-3" v-if="content == ''" style="color:grey;">
                  No text available ...
                </div>
                <div
                  class="ql-editor content-html"
                  v-html="content"
                  v-else
                ></div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dedent from "dedent";
import hljs from "highlight.js";
import debounce from "lodash/debounce";
import { quillEditor } from "vue-quill-editor";
// highlight.js style
import "highlight.js/styles/tomorrow.css";
// import theme style
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  props: ["dialog"],
  name: "quill-example-snow",
  title: "Theme: snow",
  components: {
    quillEditor
  },
  data() {
    return {
      content: "",
    };
  }
};
</script>

<style>
.content-html img {
  width: 100%;
  height: 100%;
}
</style>

<style scoped>
.output {
  max-width: 375px;
  width:25%;
  min-width: 320px;
  height: 70vh;
  margin: 0;
  border: 1px solid #ccc;
  overflow-y: auto;
  resize: vertical;
}

.output-layout {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
